module.exports = __webpack_public_path__ + "static/media/LivingRoom.459de176.mp3";